import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./auto_add_scannable_items_mode.js";
//#region src/auto_add_scannable_items_mode_helper.ts
var auto_add_scannable_items_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(mode) {
	switch (mode) {
		case "no": return "No";
		case "priced-items": return "Priced Items";
		case "all-items": return "All Items";
	}
}
//#endregion
export { auto_add_scannable_items_mode_helper_exports, name };

//# sourceMappingURL=auto_add_scannable_items_mode_helper.js.map